import React, { useState } from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import EventIcon from '@material-ui/icons/Event';
import { SectionCard, TEXT, SURFACE, SPACE } from '../../shared_components';
import { backendDateFormat, fieldDateFormat } from '../../../../constants';

const DateRangeFilter = ({ onApply }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleApply = () => {
    if (!startDate && !endDate) return;

    onApply({
      startDate: startDate ? moment(startDate).format(backendDateFormat) : undefined,
      endDate: endDate ? moment(endDate).format(backendDateFormat) : undefined,
    });
  };

  const handleReset = () => {
    setStartDate(null);
    setEndDate(null);

    onApply();
  };

  return (
    <SectionCard style={{ marginBottom: SPACE.md, padding: '10px' }}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={12} sm="auto">
          <Grid container spacing={2} alignItems="center" wrap="nowrap">
            <Grid item>
              <EventIcon style={{ color: TEXT.tertiary, fontSize: 28 }} />
            </Grid>
            <Grid item>
              <Typography variant="subtitle1" style={{ fontWeight: 700, color: TEXT.primary, lineHeight: 1.4 }}>
                Date Range
              </Typography>
              <Typography variant="caption" style={{ color: TEXT.secondary }}>
                Select the period to view data
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs style={{ borderLeft: `1px solid ${SURFACE.divider}`, paddingLeft: SPACE.lg }}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <KeyboardDatePicker
                  fullWidth
                  label="Start Date"
                  format={fieldDateFormat}
                  inputVariant="outlined"
                  margin="dense"
                  InputLabelProps={{ shrink: true }}
                  maxDate={endDate || undefined}
                  value={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <KeyboardDatePicker
                  fullWidth
                  label="End Date"
                  format={fieldDateFormat}
                  inputVariant="outlined"
                  margin="dense"
                  InputLabelProps={{ shrink: true }}
                  minDate={startDate || undefined}
                  value={endDate}
                  onChange={(date) => setEndDate(date)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <div style={{ display: 'flex', alignItems: 'center', height: '100%', gap: 8 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    disableElevation
                    disabled={!startDate && !endDate}
                    onClick={handleApply}
                    size='small'
                    style={{ minWidth: 120 }}
                  >
                    Apply
                  </Button>
                  <Button variant="outlined" size='small' style={{ minWidth: 120 }} onClick={handleReset}>
                    Reset
                  </Button>
                </div>
              </Grid>
            </Grid>
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
    </SectionCard>
  );
};

export default DateRangeFilter;
